// Theme colors and constants for Crazy 8's game
export const colors = {
  // Primary colors
  primary: '#3498db',       // Blue
  primaryHover: '#2980b9',
  primaryLight: '#ebf3fd',
  
  // Secondary colors  
  secondary: '#27ae60',     // Green
  secondaryHover: '#229954',
  secondaryLight: '#d4edda',
  
  // Status colors
  success: '#27ae60',
  successHover: '#229954',
  warning: '#f39c12',
  warningHover: '#e67e22',
  error: '#e74c3c',
  errorHover: '#c0392b',
  
  // Neutral colors
  dark: '#2c3e50',
  darkGray: '#7f8c8d',
  lightGray: '#95a5a6',
  border: '#ddd',
  background: '#f8f9fa',
  white: '#fff',
  
  // Game specific
  cardBackground: '#fff',
  tableBackground: '#27ae60',
  
  // Authentication specific
  authOverlay: 'rgba(0, 0, 0, 0.5)',
  formBackground: '#fff',
  inputBorder: '#ddd',
  inputFocus: '#3498db'
};

export const shadows = {
  small: '0 2px 4px rgba(0, 0, 0, 0.1)',
  medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
  large: '0 10px 30px rgba(0, 0, 0, 0.3)',
  card: '0 2px 8px rgba(0, 0, 0, 0.15)'
};

export const borderRadius = {
  small: '4px',
  medium: '8px',
  large: '12px',
  round: '50%'
};

export const transitions = {
  fast: '0.2s ease',
  medium: '0.3s ease',
  slow: '0.5s ease'
};

export const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1200px'
};